import { v4 as uuid } from 'uuid';
import { db } from './db';
import { useNoteSyncStore } from "./offline/noteSyncStore";

export async function queueNote(
  udprn: number,
  endpoint: string,
  body: any
): Promise<number> {
  const client_created_at = new Date().toISOString();
  const local_id = uuid();
  const key = await db.notesQueue.put({
    local_id,
    udprn,
    payload: {
      endpoint,
      body: {
        client_created_at,
        local_id,
        ...body,
      },
    },
    created_at_client: client_created_at,
    retry_count: 0,
    last_attempt_at: null,
    error: null,
    queue_status: "pending",
  });

  const state = useNoteSyncStore.getState();
  await state.refreshCounts();
  if (navigator.onLine) {
    state.syncNow({ includeFailed: true });
  }

  return key as number;
}

// syncNotesQueue is kept for backwards-compat callers; new logic lives in offline/noteSync.ts
// export async function syncNotesQueue(api: any) {
//   await syncQueuedNotes({ api });
// }

// export async function searchAddresses({
//   prefixes,
//   postcodePrefix,
//   thoroughfareTerm,
//   limit = 100
// }: {
//   prefixes: string[]; 
//   postcodePrefix?: string;
//   thoroughfareTerm?: string;
//   limit?: number;
// }) {
//   let collection = db.addresses.where("prefix").anyOf(prefixes);

//   if (postcodePrefix) {
//     const p = postcodePrefix.replace(/\s+/g, "").toUpperCase();
//     if (p.length >= 2) {
//       collection = db.addresses.where("postcode_normalised").startsWith(p);
//     }
//   }

//   let results = await collection.limit(limit * 5).toArray();

//   if (thoroughfareTerm) {
//     const t = thoroughfareTerm.toLowerCase();
//     results = results.filter(a => a.thoroughfare?.toLowerCase().includes(t));
//   }

//   return results.slice(0, limit);
// }

// export async function deletePrefix(prefix: string) {
//   await db.transaction(
//     'rw',
//     [db.addresses, db.addressStates, db.customers, db.notesSynced],
//     async () => {
//       await db.addresses.where("prefix").equals(prefix).delete();
//       await db.addressStates.where("prefix").equals(prefix).delete();

//       await db.customers.where("prefix").equals(prefix).delete();

//       await db.notesSynced.where("prefix").equals(prefix).delete();
//     }
//   );

//   // update meta
//   const meta = await db.meta.get("offlinePrefixes");
//   const filtered = meta?.value.filter((p: string) => p !== prefix);
//   await db.meta.put({ key: "offlinePrefixes", value: filtered });
// }
